import { render } from "./HistoricoSoportes.vue?vue&type=template&id=22a7b7b3"
import script from "./HistoricoSoportes.vue?vue&type=script&lang=js"
export * from "./HistoricoSoportes.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__